import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '#components/m/Tooltip'
import Text from '#components/a/Text'

export function TriggerWithTooltip({children, text, placement, modifiers, testId}) {
  return (
    <Tooltip
      trigger={children}
      modifier={modifiers}
      triggerModifier={['hidden-overflow']}
      placement={placement || 'bottom'}
      triggerAction="hover"
      tooltipShown
      testId={testId}
    >
      <div className="meineazubis__tooltip">
        <Text modifier="extrasmall" text={text} />
      </div>
    </Tooltip>
  )
}

TriggerWithTooltip.propTypes = {
  children: PropTypes.any,
  modifiers: PropTypes.array,
  placement: PropTypes.string,
  text: PropTypes.string,
  testId: PropTypes.string,
}
